import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const ServiceOptionsModule = {
  namespaced: true,
  actions: {
    async saveSelectedOptions ({ commit, state }, { option }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation
        serviceOptions ($changeServiceOptionsInput: ChangeServiceOptionsInput!){
            changeServiceOptions(changeServiceOptions: $changeServiceOptionsInput) {
                success
            }
        }`,
        variables: {
          changeServiceOptionsInput: {
            anonymousCallRejection: !option.anonymousCallRejection
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'serviceOptions', { root: true })
        commit('addMessage', { type: 'success', message: 'Service erfolgreich aktiviert' }, { root: true })
        return true
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    },
    async saveDeactivateOptions ({ commit, state }, { option }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation
        serviceOptions ($changeServiceOptionsInput: ChangeServiceOptionsInput!){
            changeServiceOptions(changeServiceOptions: $changeServiceOptionsInput) {
                success
            }
        }`,
        variables: {
          changeServiceOptionsInput: {
            anonymousCallRejection: !option.anonymousCallRejection
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'serviceOptions', { root: true })
        commit('addMessage', { type: 'success', message: 'Service erfolgreich deaktiviert' }, { root: true })
        return true
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    }
  }
}

export {
  ServiceOptionsModule
}
